import React, { useState } from "react";
import GanttRow from "./GanttRow";
import GanttTodayLine from "./GanttTodayLine";

export default function GanttGrid(props) {

  var {
    projects,
    timelineStart,
    weekWidth,
    rowHeight,
    onMoveClick,
	ganttMode
  } = props;

  var [expandedProjects, setExpandedProjects] = useState({});

  function toggleProject(projectId) {
    setExpandedProjects(function (prev) {
      return {
        ...prev,
        [projectId]: !prev[projectId]
      };
    });
  }

  function isExpanded(projectId) {
    return expandedProjects[projectId] === true;
  }

  function getTotalRows() {
    var count = 0;

    projects.forEach(function (project) {
      count += 1;
      if (isExpanded(project.id)) {
        count += project.moves.length;
      }
    });

    return count;
  }

  var totalHeight = getTotalRows() * rowHeight;

  return (
    <div style={styles.container}>

      {/* TODAY LINE */}
      <GanttTodayLine
        timelineStart={timelineStart}
        weekWidth={weekWidth}
        height={totalHeight}
      />

      {/* ROWS */}
      {projects.map(function (project) {
        return (
          <div key={project.id}>

            {/* PROJECT ROW */}
            <GanttRow
              type="project"
              label={project.name}
              status={project.status}
              expanded={isExpanded(project.id)}
              onToggle={function () {
                toggleProject(project.id);
              }}
			  plannedStart={project.plannedStart}
			   plannedEnd={project.plannedEnd}
			   actualStart={project.actualStart}
			   actualEnd={project.actualEnd}
              timelineStart={timelineStart}
              weekWidth={weekWidth}
              rowHeight={rowHeight}
			  ganttMode={ganttMode}
            />

            {/* MOVE ROWS */}
            {isExpanded(project.id) &&
              project.moves.map(function (move) {
                return (
                  <GanttRow
                    key={move.id}
                    type="move"
                    label={move.label}
                    status={move.status}
					plannedStart={project.plannedStart}
					 plannedEnd={project.plannedEnd}
					 actualStart={project.actualStart}
					 actualEnd={project.actualEnd}
                    timelineStart={timelineStart}
                    weekWidth={weekWidth}
                    rowHeight={rowHeight}
                    onClick={function () {
                      if (onMoveClick) {
                        onMoveClick(move);
                      }
                    }}
					ganttMode={ganttMode}
                  />
                );
              })}
          </div>
        );
      })}

    </div>
  );
}

const styles = {

  container: {
    position: "relative",
    width: "100%",
	background: "linear-gradient(180deg, #2F343C 0%, #1F2329 100%)",
	boxShadow: "inset 0 1px 0 rgba(255,255,255,0.04)"
  }
};
